if (!customElements.get('deferred-media')) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();

      this.playBtn = this.querySelector('.js-play-video');
      this.renderedVideo = this.querySelector('.js-rended-video');

      if (!this.playBtn || !this.renderedVideo) return;

      this.bindEvents();
    }

    bindEvents() {
      this.playBtn.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      this.playBtn.classList.add('is-loading');
      if (window.pauseAllMedia) window.pauseAllMedia();

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(
          this.querySelector('template').content.firstElementChild.cloneNode(true)
        );

        this.setAttribute('loaded', true);
        const deferredElement = this.renderedVideo.appendChild(
          content.querySelector('video, model-viewer, iframe')
        );
        if (focus) deferredElement.focus();
      }

      this.playBtn.classList.remove('is-loading');
    }
  }

  customElements.define('deferred-media', DeferredMedia);
}
